// audioSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isPlaying: false, // change to null and audioLink
  audioLinks: [],
  currentAudioIndex: 0,
  repeatMode: "off",
  showAudioLinks: false,
  showFooter: false,
  audioListId: null,
  audioId: null,
  currentTime: 0,
  duration: 0,
};

const AudioSlice = createSlice({
  name: "audio",
  initialState,
  reducers: {
    togglePlayPause: (state) => {
      state.isPlaying = !state.isPlaying;
    },
    setPlayState: (state, action) => {
      state.isPlaying = action.payload;
    },
    setAudioLinks: (state, action) => {
      state.audioLinks = action.payload;
      state.currentAudioIndex = 0; // Reset to the first audio
      state.audioId = action.payload[0]?.audioId || null;
    },
    setCurrentAudioIndex: (state, action) => {
      state.currentAudioIndex = action.payload;
      state.audioId = state.audioLinks[action.payload]?.audioId || null;
    },
    toggleRepeatMode: (state) => {
      const modes = ["off", "one-time", "infinite"];
      const currentIndex = modes.indexOf(state.repeatMode);
      state.repeatMode = modes[(currentIndex + 1) % modes.length];
    },
    shuffleAudioLinks: (state) => {
      const currentAudio = state.audioLinks[state.currentAudioIndex];
      const shuffled = state.audioLinks
        .filter((audio) => audio.audioId !== currentAudio.audioId)
        .sort(() => Math.random() - 0.5);
      shuffled.splice(
        Math.floor(Math.random() * shuffled.length),
        0,
        currentAudio
      );
      state.audioLinks = shuffled;
      state.currentAudioIndex = shuffled.findIndex(
        (audio) => audio.audioId === currentAudio.audioId
      );
    },
    toggleShowAudioLinks: (state, action) => {
      state.showAudioLinks = !state.showAudioLinks;
    },
    setShowAudioLinks: (state) => {
      state.showAudioLinks = true;
    },
    setShowFooter: (state, action) => {
      state.showFooter = action.payload;
    },
    setAudioListId: (state, action) => {
      state.audioListId = action.payload;
    },
    setAudioId: (state, action) => {
      state.audioId = action.payload;
    },
    setCurrentTime: (state, action) => {
      state.currentTime = action.payload;
    },
    setDuration: (state, action) => {
      state.duration = action.payload;
    },
  },
});

export const {
  togglePlayPause,
  setPlayState,
  setAudioLinks,
  setCurrentAudioIndex,
  toggleRepeatMode,
  shuffleAudioLinks,
  toggleShowAudioLinks,
  setShowAudioLinks,
  setShowFooter,
  setAudioListId,
  setAudioId,
  setCurrentTime,
  setDuration,
} = AudioSlice.actions;

export default AudioSlice.reducer;
